module.exports = __webpack_public_path__ + "img/3-sk-grant.70051c7a.jpg";